import "../RenderSteps/tenantonboard.css";
import AddTraspButton from "../../firstTimeUserExperience/commonCom/AddTraspButton";
import { OnboardingStepsEnums } from "../../../constants/onboarding";
import AddButtonWithArrow from "../../firstTimeUserExperience/commonCom/AddButtonWithArrow";
import { GetImages } from "../../../utils/GetImages";

const Footer = ({
  currentStepIndex,
  stepsCount,
  stepFivePart2,
  goPrevStep,
  handleSubmit,
  steps,
  loading
}) => {

  let buttonname = steps[currentStepIndex] == OnboardingStepsEnums.Signature ? "Review & Sign" : steps[currentStepIndex] == OnboardingStepsEnums.ApplicationFees ? "Pay Fee" : "Next";
  return (
    <>
      
        <div className="flexRow gap-2">
          {currentStepIndex > 0 && (
             <AddTraspButton
              type="button"
              bname={"Back"}
              onClick={goPrevStep}
              border={true}
              width="fit-content"
            />
          )}
          <AddButtonWithArrow
            buttonname={buttonname}
            onClick={handleSubmit}
            disabled={loading}
            // minWidth={'77px'}
            loading={loading}
          />
        </div>
     
    </>
  );
};
export default Footer;
